export function contrastTextColor(bgColor?: string) {
  return !bgColor ||
    parseInt(bgColor.slice(1, 3), 16) * 0.299 +
      parseInt(bgColor.slice(3, 5), 16) * 0.587 +
      parseInt(bgColor.slice(5, 7), 16) * 0.114 >
      186
    ? 'black'
    : 'white';
}
